import { createAsyncThunk } from "@reduxjs/toolkit";
import { endpoints } from "../../../api/endpoints";
import { ICreateJobResponse } from "../../../api/types/jobs/ICreateJobResponse";
import { IJobParams } from "../../../api/types/jobs/IJobParams";
import { RootState } from "../../rootState";
import { createJobFromTemplate } from "./createJobFromTemplate";
import { withJobParentId } from "./utils/withJobParentId";

export const createJobTemplate = createAsyncThunk<
  ICreateJobResponse,
  IJobParams,
  { state: RootState }
>("jobs/create", async (param, thunkAPI) => {
  const jobParams = withJobParentId(param, thunkAPI.getState());
  const response = await endpoints.job.create(jobParams, thunkAPI.signal);
  if (response.jobID) {
    if (jobParams.schedule_days.length === 0 || jobParams.schedule_time.length === 0)
      thunkAPI.dispatch(createJobFromTemplate(jobParams));
    return response;
  }
  throw new Error(response?.error ?? `Не удалось сохранить шаблон "${param.name}"`);
});
